import { faker } from "@faker-js/faker";
import { Factory } from "fishery";
import { sample } from "lodash";
import { DateTime } from "luxon";
import {
  DistributionBatch,
  DistributionBatches,
} from "../components/DistributionWorkflow/StepComponents/SelectDistributionBatchStep/DistributionBatchesTable/types";
import { toGlobalId } from "../utils/graphql_utils";
import { moneyFactory, walletFactory } from "./money.factory";

interface DistributionBatchTransientParams {
  arena: {
    id: string;
    name: string;
  };
}

export const distributionBatchFactory = Factory.define<
  DistributionBatch,
  DistributionBatchTransientParams
>(({ sequence, transientParams }) => {
  return {
    id: toGlobalId("DistributionBatchObjectType", sequence),
    description: faker.lorem.sentence(),
    effectiveDate: DateTime.fromJSDate(faker.date.recent()).toISODate(),
    distributionCount: faker.number.int({
      max: 200,
    }),
    amountPaidViaAutomatedPayments: moneyFactory.build(),
    batchTotalDetails: {
      amountPayable: walletFactory.build(),
    },
    amountPaid: {
      ach: walletFactory.build(),
      check: walletFactory.build(),
      manual: walletFactory.build(),
    },
    arena: {
      __typename: "ArenaObjectType" as const,
      id: toGlobalId("ArenaObjectType", faker.number.int()),
      name: faker.company.name(),
      ...transientParams.arena,
    },
    entity: {
      __typename: "AccountObjectType" as const,
      id: toGlobalId("AccountObjectType", faker.number.int()),
      name: faker.company.name(),
    },
  };
});

interface DistributionBatchesTransientParams {
  distributionCountPerPage?: number;
  arenas: {
    id: string;
    name: string;
  }[];
}

export const distributionBatchesFactory = Factory.define<
  DistributionBatches,
  DistributionBatchesTransientParams
>(({ transientParams }) => {
  const { distributionCountPerPage = 20 } = transientParams;
  const batches: DistributionBatch[] = [];

  for (let i = 0; i < distributionCountPerPage; i++) {
    batches.push(
      distributionBatchFactory.build(
        {},
        {
          transient: {
            arena: transientParams.arenas ? sample(transientParams.arenas) : undefined,
          },
        },
      ),
    );
  }

  return {
    count: 50,
    pageInfo: {
      endCursor: faker.string.alphanumeric(),
      hasNextPage: true,
    },
    edges: batches.map((node) => ({
      node,
    })),
  };
});
